import React from "react";
import { Save, Terminal, ChartLine, Users, Activity, Stethoscope } from "lucide-react";
import { ProGatedButton } from "@/components/ProTools";


/** Sticky toolbar for the Builder page. */
export function BuilderToolbar({ cfg, setField, strategyId, busy, proBusy,
                                 onCompile, onCompileMT, onBacktest, onBacktestReal,
                                 onShare, onDeploy, onSave, onDownload, onDoctor }) {
  return (
    <>
      <input
        data-testid="builder-name-input"
        value={cfg.name}
        onChange={(e)=>setField("name", e.target.value)}
        className="input-dark w-72 !py-1.5"
        placeholder="Strategy name"
      />
      <div className="flex items-center gap-1 border border-white/10 rounded p-0.5" data-testid="builder-platform-toggle">
        <PlatformButton value="mt4" current={cfg.platform} onClick={()=>setField("platform","mt4")}/>
        <PlatformButton value="mt5" current={cfg.platform} onClick={()=>setField("platform","mt5")}/>
      </div>
      <span className="chip">VISUAL</span>
      <div className="ml-auto flex flex-wrap gap-2">
        <ProGatedButton testId="builder-compile-btn"
          label={proBusy ? "…" : "Compile-check"} icon={<Terminal size={13}/>}
          onClick={onCompile}/>
        <ProGatedButton testId="builder-compile-mt-btn"
          label={proBusy ? "…" : "MetaEditor"} icon={<Terminal size={13}/>}
          onClick={onCompileMT}/>
        <ProGatedButton testId="builder-backtest-btn"
          label={proBusy ? "…" : "Backtest"} icon={<ChartLine size={13}/>}
          onClick={onBacktest}/>
        <ProGatedButton testId="builder-backtest-real-btn"
          label="Real bars" icon={<ChartLine size={13}/>}
          onClick={onBacktestReal}/>
        <ProGatedButton testId="builder-share-btn"
          label="Share" icon={<Users size={13}/>}
          onClick={onShare}/>
        {onDoctor && strategyId && (
          <ProGatedButton testId="builder-doctor-btn"
            label="Doctor" icon={<Stethoscope size={13}/>}
            onClick={onDoctor}/>
        )}
        <ProGatedButton testId="builder-deploy-btn"
          label="Deploy" icon={<Activity size={13}/>}
          onClick={onDeploy}
          className="!border-[var(--profit)]/40 hover:!bg-[var(--profit)]/10 hover:!text-[var(--profit)]"/>
        <button data-testid="builder-save-btn" onClick={onSave} disabled={busy} className="btn-primary flex items-center gap-2">
          <Save size={14}/> {strategyId ? "Save" : "Create"}
        </button>
        <button data-testid="builder-download-btn" onClick={onDownload} className="btn-outline flex items-center gap-2">
          Download .{cfg.platform === "mt5" ? "mq5" : "mq4"}
        </button>
      </div>
    </>
  );
}


function PlatformButton({ value, current, onClick }) {
  const active = current === value;
  return (
    <button data-testid={`platform-${value}`} onClick={onClick}
      className={`px-3 py-1 text-xs font-mono rounded transition-colors ${active ? "bg-[var(--accent)] text-black" : "text-[var(--text-secondary)] hover:text-white"}`}>
      {value.toUpperCase()}
    </button>
  );
}
